import getCarrier from './getCarrier';
export const filterParamsForAttPlans = ['T-Mobile', 'TMO', 'VZ', 'TF'];

export const injectCustomPlansAndRemoveRegular = ({
  plans,
  customPlans,
  sub,
}) => {
  const carrier = getCarrier(sub);
  let filteredPlans = [];
  const filteredGeneralPlans =
    carrier === 'tracfone' ? filterTFPlansBySubCarrier(plans, sub) : plans;
  const filteredCustomPlans = customPlans;

  filteredCustomPlans
    .filter(
      (customPlan) => customPlan[`${carrier}_plan`] && customPlan.is_effective,
    )
    .forEach((customPlan) => {
      const planIndex = filteredGeneralPlans.findIndex(
        (plan) => plan.id === customPlan[`${carrier}_plan`],
      );
      if (planIndex !== -1) {
        filteredPlans.push({
          ...filteredGeneralPlans[planIndex],
          price: customPlan.price,
        });
      }
    });

  return filteredPlans;
};

export const filterTFPlansBySubCarrier = (plans, sub) => {
  return plans.filter((plan) =>
    plan.supported_carriers.includes(sub.sub_carrier),
  );
};
